import bowser from 'bowser'
import {
  H265_MIN_IOS_SAFARI_VERSION,
  H265_MIN_IOS_VERSION,
  H265_MIN_OSX_SAFARI_VERSION,
  H265_MIN_OSX_VERSION,
  VP9_MIN_CHROME_VERSION
} from '../constants/device'
import { Codec } from '../enums/ContentType'
import { isMimeTypeSupported } from './mimeTypes'

export class Device {
  static get isMobile(): boolean {
    return bowser.mobile
  }

  static get isTablet(): boolean {
    return bowser.tablet
  }

  static get android(): boolean {
    return bowser.android
  }

  static get iOS(): boolean {
    return bowser.ios
  }

  static get os(): string {
    return bowser.osname
  }

  static get osversion(): string {
    return bowser.osversion as string
  }

  static get browser(): string {
    return bowser.name
  }

  static get supportsVP9(): boolean {
    return !!(
      bowser.chrome &&
      bowser.compareVersions([
        VP9_MIN_CHROME_VERSION,
        String(bowser.version)
      ]) <= 0 &&
      isMimeTypeSupported(Codec.vp9)
    )
  }

  static get supportsH265(): boolean {
    const hasMobileSupport = !!(
      bowser.safari &&
      bowser.ios &&
      bowser.compareVersions([
        H265_MIN_IOS_VERSION,
        String(bowser.osversion)
      ]) <= 0 &&
      bowser.compareVersions([
        H265_MIN_IOS_SAFARI_VERSION,
        String(bowser.version)
      ]) <= 0
    )
    const hasDesktopSupport = !!(
      bowser.safari &&
      bowser.mac &&
      bowser.compareVersions([
        H265_MIN_OSX_VERSION,
        String(bowser.osversion)
      ]) <= 0 &&
      bowser.compareVersions([
        H265_MIN_OSX_SAFARI_VERSION,
        String(bowser.version)
      ]) <= 0
    )

    return !!(
      (hasMobileSupport || hasDesktopSupport) &&
      (isMimeTypeSupported(Codec.h265) || isMimeTypeSupported(Codec.h265Mobile))
    )
  }

  static get deviceType(): 'tablet' | 'mobile' | 'desktop' {
    if (this.isTablet) {
      return 'tablet'
    } else if (this.isMobile) {
      return 'mobile'
    } else {
      return 'desktop'
    }
  }
}
